import React from 'react';
import styled from '@emotion/styled';

interface CloseButtonProps {
  onClick: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => (
  <StyledButton onClick={onClick} aria-label="Close">
    &times;
  </StyledButton>
);

const StyledButton = styled.button`
  width: 32px;
  height: 32px;
  border: 2px solid #7b8794;
  border-radius: 50%;
  background-color: transparent;
  color: #7b8794;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #323f4b;
    color: white;
  }
`;

export default CloseButton;
